export default __webpack_public_path__ + "static/media/Content4.0897bafc.png";